import { getUserData } from './firebase'

const getToken = async () => {
  // Check if localStorage is available
  // eslint-disable-next-line no-undef
  let token = typeof localStorage !== 'undefined' ? localStorage?.getItem('token') : null

  try {
    const user = await getUserData() // Assuming this is your function to get the current user
    if (user) {
      const idToken = await user.getIdToken(true) // Force refresh of the ID token
      if (token !== idToken) {
        window.localStorage.setItem('token', idToken)
        token = idToken // Update token if changed
      }
    }
  } catch (error) {
    console.warn('Unable to fetch user token', error)
  }

  return token
}

function memoizeAsyncWithExpiry (fn, expiryTime) {
  const cache = new Map()
  const pendingPromises = new Map() // To store pending promises for ongoing requests

  return async (...args) => {
    const key = args.length ? JSON.stringify(args) : '__noargs__'
    const now = Date.now()

    // Check if cached and not expired
    if (cache.has(key)) {
      const { value, expiry } = cache.get(key)
      if (now < expiry) {
        return value // Return cached value if it's still valid
      } else {
        cache.delete(key) // Remove expired cache entry
      }
    }

    // Check if a promise for the same key is pending
    if (pendingPromises.has(key)) {
      return pendingPromises.get(key) // Return the pending promise
    }

    // Call the function and store the result (add to pending promises)
    const promise = fn(...args).then(result => {
      cache.set(key, { value: result, expiry: now + expiryTime })
      pendingPromises.delete(key) // Remove the promise once resolved
      return result
    }).catch(error => {
      pendingPromises.delete(key) // Ensure pending promise is removed on failure
      throw error
    })

    pendingPromises.set(key, promise) // Store the pending promise
    return promise
  }
}

// Memoize getToken with a 60-second expiry time
export default memoizeAsyncWithExpiry(getToken, 60000)
